import { render, staticRenderFns } from "./WorkspaceCard.vue?vue&type=template&id=731e3419&scoped=true"
import script from "./WorkspaceCard.vue?vue&type=script&lang=ts"
export * from "./WorkspaceCard.vue?vue&type=script&lang=ts"
import style0 from "./WorkspaceCard.vue?vue&type=style&index=0&id=731e3419&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e3419",
  null
  
)

export default component.exports